module.exports = __webpack_public_path__ + "static/logo-white-3962fb7d24bb8657bda0feba8a8fcbe9.svg";